import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

import {PageTitle} from '@br/mg-components';

const ErrorPage = (): JSX.Element => {
    const {t} = useTranslation(['errors']);
    return (
        <>
            <PageTitle title={t('errors:errorPageTitle', 'Something went wrong')} />
            <Trans i18nKey="errors:errorPageMessage">
                <p>Something unexpected went wrong. Please try again later.</p>
            </Trans>
        </>
    );
};

export default ErrorPage;
